import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALITEMIMPORT_LOAD_BY_ID,

    ACTION_TRIALITEMIMPORT_SAVE,

    ITrialItemImportLoadByIdAction,
    ITrialItemImportLoadFailureAction,
    ITrialItemImportLoadSuccessAction,

    ITrialItemImportSaveAction,
    ITrialItemImportSaveSuccessAction,
    ITrialItemImportSaveFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

} from "../actions/trialItemImport";
import { trialItemImportApi } from "../services/trialItemImport";


export const
    setTrialItemImportEpic = (action$): Observable<ITrialItemImportSaveSuccessAction | ITrialItemImportSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALITEMIMPORT_SAVE)
            .mergeMap((action: ITrialItemImportSaveAction) => {
                return trialItemImportApi
                    .setTrialItemImport(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialItemImport, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    };

